// extracted by mini-css-extract-plugin
module.exports = {"list-page":"listings_list-page__P2YeW","heading":"listings_heading__33yIw","desc":"listings_desc__RANXg","br":"listings_br__1YfeC","text":"listings_text__3f-h5"};